import './index.scss';

import React, {useState} from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import {MAX_CATEGORY_NAME_LENGTH} from '../../tools';
import {useSuggestions} from "../../containers/Tools/useSuggestions";

const EditCategory = ({categories, categoryObject, onClose, onSave, onRemove}) => {
	const [categoryData, setCategoryData] = useState({
		category: categoryObject.category,
	});

	const {
		suggestions,
		showSuggestions,
		updateSuggestions,
		hideSuggestions
	} = useSuggestions(categories, cat => cat.category);

	const handleChange = (e) => {
		const {name, value} = e.target;
		setCategoryData(prev => ({
			...prev,
			[name]: value
		}));

		if (name === 'category') {
			updateSuggestions(value);
		}
	};

	const handleSuggestionClick = (suggestion) => {
		setCategoryData(prev => ({...prev, category: suggestion}));
		hideSuggestions();
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		onSave({
			...categoryObject,
			...categoryData,
			oldCategory: categoryObject.category
		});
	};

	return (
		<Modal onClose={onClose}>
			<form onSubmit={handleSubmit} className="edit-category-form">
				<h2>Edit Category</h2>
				<div className="form-group">
					<div className="form-group__field">
						<label htmlFor="category">Category Name:</label>
						<input
							type="text"
							id="category"
							name="category"
							value={categoryData.category}
							onChange={handleChange}
							required
							maxLength={MAX_CATEGORY_NAME_LENGTH}
						/>
					</div>
					{showSuggestions && (
						<ul className="category-suggestions">
							{suggestions.map((suggestion, index) => (
								<li key={`${suggestion}-${index}`}>
									<button
										type="button"
										className="category-suggestions__item"
										onClick={() => handleSuggestionClick(suggestion)}
									>
										{suggestion}
									</button>
								</li>
							))}
						</ul>
					)}
				</div>
				<div className="form-actions">
					<button type="submit" className="btn-save">Save</button>
					<button type="button" className="btn-remove" onClick={() => onRemove(categoryObject)}>
						Remove
					</button>
					<button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
				</div>
			</form>
		</Modal>
	);
};

EditCategory.propTypes = {
	categories: PropTypes.array.isRequired,
	categoryObject: PropTypes.shape({
		id: PropTypes.string.isRequired,
		category: PropTypes.string.isRequired,
	}).isRequired,
	onClose: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired
};

export default EditCategory;
